
/* eslint-disable react/display-name */
/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import { usePopper } from 'react-popper';
import { Float, usePrompt } from '.';
import { PopperInner, PopperMount } from '../app/canvas/ui/PopperElements';
import { Divider, Flexer } from '../app/dashboard/elements/LayoutElements';
import { DropButton } from './DropButton';

type DatePopperProps = {
    date: Date | string,
    onChange: (date: Date) => void,
    disabled?: boolean,
    quick?: boolean,
};

export const DatePopper = React.memo<DatePopperProps>(({ quick, date, onChange, disabled }) => {
    const normalizedDate = typeof date === 'string' ? new Date(date) : date;

    const [open, setOpen] = useState(false);

    const [refElmt, setRefElmt] = useState(null);
    const [popElmt, setPopElmt] = useState(null);

    const { styles, attributes } = usePopper(refElmt, popElmt, { placement: 'bottom-start' });

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: () => setOpen(false),
    });

    const onToggle = useCallback(() => setOpen(!open), [open, setOpen]);

    return <Flexer ref={promptRef} flex="row">
        <Flexer ref={setRefElmt}>
            <DropButton active={open} onClick={!disabled ? onToggle : null} disabled={disabled}>
                <span>{normalizedDate?.toLocaleDateString() ?? 'Not Set'}</span>
            </DropButton>
        </Flexer>
        {open && <PopperMount ref={setPopElmt} style={styles.popper} {...attributes.popper}>
            <PopperInner direction="down" offset=".5">
                <Float>
                    <Flexer padding=".5">
                        <DayPicker
                            mode="single"
                            selected={normalizedDate}
                            onSelect={onChange}
                            modifiersClassNames={{
                                selected: 'my-selected',
                                today: 'my-today'
                            }}
                            modifiersStyles={{
                                disabled: { fontSize: '75%' }
                            }}
                        />
                        {quick && <Flexer>
                            <Divider mode="horizontal" />
                            <Flexer>
                                <span>Today</span>
                                <span>Tomorrow</span>
                                <span>Next Week</span>
                            </Flexer>
                        </Flexer>}
                    </Flexer>
                </Float>
            </PopperInner>
        </PopperMount>}
    </Flexer>;
});
